import ContactRepository from '@/services/ContactRepository';

const SCREEN_TYPE = {
  BLENDED: 'blended',
  TUTOR: 'tutor',
};

export default {
  data() {
    return {
      coverTeacher: false,
    };
  },
  methods: {
    async getTeacherCoverInfo(screen = SCREEN_TYPE.TUTOR) {
      const params = screen === SCREEN_TYPE.TUTOR ? this.contact.lms_core_user_id : this.studentDetail.lms_core_user_id;
      const response = await ContactRepository.getTeacherCoverInfo(params);
      if (response.message === 'Success') {
        if (_.get(response, 'data.is_disagree', false)) {
          this.coverTeacher = true;
        } else {
          this.coverTeacher = false;
        }
      }
    },
    async changeRequest(screen = SCREEN_TYPE.TUTOR) {
      const loading = this.$loading.show();
      const params = {
        lms_core_user_id: screen === SCREEN_TYPE.TUTOR ? this.contact.lms_core_user_id : this.studentDetail.lms_core_user_id,
        is_disagree: this.coverTeacher ? 1 : 0,
        student_id: this.studentId,
      };
      const response = await ContactRepository.changeRequestCoverTeacher(params);
      loading.hide();
      if (response.message === 'Success') {
        this.$swal({
          title: `${this.coverTeacher ? 'Đã thực hiện yêu cầu không đổi giáo viên cover' : 'Phụ huynh / học sinh đồng ý đổi giáo viên cover'}`,
        });
      }
    },
  },
};
